<template>
  <v-card
    outlined
    elevation="4"
  >
    <v-container>
      <div class="text-overline mb-3">
        {{ $t('stocks.stockStatus.buyPrices.title.' + type) }}
      </div>
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent
      >
        <FormFields
          :form="form"
          :render="formRender"
          lang-path="stocks.stockStatus.buyPrices."
        />
        <v-btn
          :text="!valid"
          :loading="loading"
          type="submit"
          color="accent"
          @click="submit"
        >
          <v-icon
            class="mr-2"
          >
            $export
          </v-icon>
          {{ $t('form.download') }}
        </v-btn>
      </v-form>
    </v-container>
  </v-card>
</template>

<script>
    import FormFields from "@/app/components/form/FormFields.component";
    import {StockStatusAPI} from "@/api/StockStatusAPI";
    import {FormAutocompleteMixin} from "@/app/mixins/FormAutocompleteMixin";
    import * as Export from "@/service/Export";
    import {
        StockBuyPricesInForm,
        StockBuyPricesInRender,
        StockBuyPricesOutForm, StockBuyPricesOutRender
    } from "@/app/overview/status/definitions/stockBuyPrices.form";

    export default {
        name: "StockBuyPrices",
        components: {FormFields},
        mixins: [FormAutocompleteMixin],
        props: {
            type: {
                type: String,
                default: 'IN' // or 'OUT'
            }
        },
        data: () => ({
            form: {},
            formRender: {},
            valid: false,
            loading: false
        }),
        watch: {
            'form.stockId': function () {
                this.form.subStockId = null;
                if (this.form.stockId) {
                    this.fetchSubStocks();
                }
            }
        },
        created: function () {
            this.form = this.type === 'IN' ? new StockBuyPricesInForm() : new StockBuyPricesOutForm();
            this.formRender = this.type === 'IN' ? new StockBuyPricesInRender() : new StockBuyPricesOutRender();
        },
        methods: {
            submit: function () {
                if (!this.valid) {
                    this.$refs.form.validate();
                    return;
                }
                // if (!this.form.dateTo) { // TODO COMMIT drop?
                //     return;
                // }
                this.loading = true;
                const data = {
                    substock_id: this.form.subStockId,
                    ...this.form
                };
                const promise = this.type === 'IN'
                    ? StockStatusAPI.exportBuyPricesIn(data)
                    : StockStatusAPI.exportBuyPricesOut(data);
                promise
                    .then(response => {
                        Export.url('data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(response.data),
                                   'buy_prices_' + this.type + '_export_' + this.form.from_date + '-' + this.form.to_date);
                    }).catch(this.snack)
                    .finally(() => this.loading = false);
            }
        }
    };
</script>

<style scoped>

</style>
